var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.875,
    height: 15.875,
    viewBox: "0 0 15.875 15.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#767171;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(.125 .125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout-1",
    transform: "translate(.375 .375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.408 2.91V.647A.647.647 0 0 0 7.761 0H.647A.647.647 0 0 0 0 .647v13.581a.647.647 0 0 0 .647.647h7.114a.647.647 0 0 0 .647-.647v-2.263",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M12.288 0H0",
    className: "cls-1",
    "data-name": "Shape",
    transform: "translate(2.587 7.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M0 6.467l3.234-3.233L0 0",
    className: "cls-1",
    "data-name": "Shape",
    transform: "translate(11.641 4.204)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.b058635ecf19ae17a93db26b0db6be8c.svg";
export { ForwardRef as ReactComponent };